let loginCondtions = [
  {
    belong: "PC",
    colSpan: 1,
    conditionType: "INPUT",
    domkey: ["account"],
    fieldcol: 16,
    isBase64: false,
    isQuickSearch: true,
    label: "云商店账号",
    labelcol: 8,
    viewAttr: 3,
    rules: "required"
  },
  {
    belong: "PC",
    colSpan: 1,
    conditionType: "INPUT",
    domkey: ["password"],
    fieldcol: 16,
    isBase64: false,
    isQuickSearch: true,
    label: "云商店账号密码",
    labelcol: 8,
    viewAttr: 3,
    rules: "required",
    otherParams: {
      type: "password"
    }
  },
  {
    belong: "PC",
    colSpan: 1,
    conditionType: "CUSTOM",
    domkey: ["explain"],
    fieldcol: 16,
    isBase64: false,
    isQuickSearch: true,
    label: "云商店登录和分享说明",
    labelcol: 8,
    viewAttr: 1,
    value: "点击查看",
    linkUrl:
      "https://e-cloudstore.com/doc.html?appId=09885365bc3c494ea848b067e5084297&maxImgWidth=800"
  }
];
const getLoginConditions = (datas = {}, labels = {}) => {
  loginCondtions = loginCondtions.map(v => {
    const domkeysForDatas = Object.keys(datas);
    const domkeysForLabel = Object.keys(labels);
    const domkey = v.domkey.join();
    if (domkeysForDatas.indexOf(domkey) >= 0) {
      v.value = datas[domkey];
    }
    if (domkeysForLabel.indexOf(domkey) >= 0) {
      v.label = labels[domkey];
    }
    return v;
  });
  return loginCondtions;
};
export default {
  loginCondtions,
  getLoginConditions
};



// WEBPACK FOOTER //
// ./ecology9/base/wea-ecode-login/constant.js